import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService, UserService } from '@org/shared-services';
import { User } from '@org/interfaces';
import { FormsModule } from '@angular/forms';
import { SysNotifyService } from '@org/shared-services';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-profile',
    imports: [CommonModule, FormsModule],
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit {
  user!: User;
  currentPassword = '';
  newPassword = '';
  confirmPassword = '';

  constructor(private userService: UserService, private sysNotify: SysNotifyService, private authService: AuthService) { }

  ngOnInit(): void {
    this.user = this.authService.currentUserValue;
  }


  updateProfile(): void {
    const profileData = {
    name: this.user.name,
    email: this.user.email
  };

  this.userService.updateProfile(this.user._id?.toString() || '', profileData).subscribe({
    next: (response) => {
     this.user = response.user;
     this.sysNotify.showSuccess('Profile updated successfully. You will be logged out to re-authenticate.', 3000, 'right', 'top');
     setTimeout(() => {
        this.authService.logout();
       window.location.href = '/login';
     }, 5000);
    },
    error: (error: HttpErrorResponse) => {
      switch (error.status) {
        case 400:
          this.sysNotify.showError(error.error.error || 'Invalid input data', 3000, 'right', 'top');
          break;
        case 403:
          this.sysNotify.showError('You are not authorized to update this profile', 3000, 'right', 'top');
          break;
        case 404:
          this.sysNotify.showError('User not found', 3000, 'right', 'top');
          break;
        case 409:
          this.sysNotify.showError('This email address is already in use. Please use a different email.', 3000, 'right', 'top');
          break;
        default:
          this.sysNotify.showError('Failed to update profile', 3000, 'right', 'top');
      }
    }
  });
}

  namebkC(user?: any): string {
    return this.userService.getBackgroundColor(user.name);
  }
    
  nameinitial(user?: any): string {
    return this.userService.getInitials(user?.name);
  } 

  resetPassword(): void {
    if (!this.currentPassword) {
      this.sysNotify.showError('Current password is required', 3000, 'right', 'top');
      return;
    }
    if (this.newPassword !== this.confirmPassword) {
      // Handle password mismatch
      return;
    }
    const pwd = { oldPassword: this.currentPassword, newPassword: this.newPassword };

    this.userService.changePassword(pwd).subscribe({
      next: () => {
        this.sysNotify.showSuccess('Password changed successfully. Please sign in again.', 3000, 'right', 'top');
        this.reset();
        setTimeout(() => {
          this.authService.logout();
          window.location.href = '/login';
        }, 2000);
      },
      error: (error: HttpErrorResponse) => {
        this.sysNotify.showError(error.error?.message || 'Failed to change password', 3000, 'right', 'top');
      }
    });
  }

  reset(): void {
    this.currentPassword = '';
    this.newPassword = '';
    this.confirmPassword = '';
  }

}
